"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["href", "onClick"];
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShareButton',
    props: {
        name: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            default: 400,
        },
        height: {
            type: Number,
            default: 500,
        },
        sameWindow: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['share-link-clicked'],
    setup(__props, { emit }) {
        const props = __props;
        function onClick(e) {
            if (!props.sameWindow) {
                e.preventDefault();
            }
            emit('share-link-clicked', props.name, props.href);
            if (!props.sameWindow) {
                window.open(props.href, '', 'status=yes, width=' + props.width + ', height=' + props.height);
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                href: __props.href,
                class: "share-link",
                rel: "noopener noreferrer",
                onClick: (0, vue_2.withModifiers)(onClick, ["left"])
            }, [
                (0, vue_2.renderSlot)(_ctx.$slots, "default")
            ], 8, _hoisted_1));
        };
    }
});
